import { EQ, combineFilters } from 'framework-listing-lib/utils/filters';
import { ASSETS_WITHOUT_FOLDERS_FILTER, FOLDER_ID, UNFILED_ASSETS_ID } from '../constants/folders';

/**
 * MO-181 | BU nav changes in listing-lib
 *
 * This method updates the hiddenFilter based on what's been defined in the top nav.
 * Since users can't change the BU value from index pages anymore, the BU filter
 * will live in @hiddenFilters.
 */
export function updateHiddenFilterForFolder({
  hiddenFilter,
  isFoldersMode,
  folderId
}) {
  const nonNullHiddenFilter = hiddenFilter || {
    filterGroups: [{
      filters: []
    }]
  };
  if (!isFoldersMode) {
    return nonNullHiddenFilter;
  }
  if (folderId === undefined || String(folderId) === UNFILED_ASSETS_ID.toString() || String(folderId) === '0') {
    return {
      filterGroups: combineFilters(nonNullHiddenFilter.filterGroups, ASSETS_WITHOUT_FOLDERS_FILTER)
    };
  }
  return {
    filterGroups: combineFilters(nonNullHiddenFilter.filterGroups, [{
      filters: [EQ(FOLDER_ID, folderId)]
    }])
  };
}